<template>
  <div class="home" style="width:100%;">
    <span>
      <v-row>
        <v-col class="d-flex flex-row align-center">
          <h1>Reports</h1>
          <v-btn class="ml-2" fab x-small color="purple" style="color: white;"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-row v-if="loader">
        <v-col>
          <v-progress-circular
            v-if="loader"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <span v-else> 
        <v-row>
          <v-col>
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="startDate"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="()=>{startDateMenu = false; getAllData()}"
              ></v-date-picker>
            </v-menu>          
          </v-col>
          <v-col>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @input="()=>{endDateMenu = false; getAllData()}"
              ></v-date-picker>
            </v-menu>          
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>Showing Results for {{this.results.totalJobs}} jobs.</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column">
            <v-card class="pb-6" outlined>
              <v-card-title>Revenue</v-card-title>
              <v-card-text style="font-size:25px;"><h1>${{this.results.totalRevenue}}</h1></v-card-text>
            </v-card>
          </v-col>
          <v-col class="d-flex flex-column">
            <v-card class="pb-6" outlined>
              <v-card-title>Tailor Expenses</v-card-title>
              <v-card-text style="font-size:25px;"><h1>${{this.results.tailorCost}}</h1></v-card-text>
            </v-card>
          </v-col>
          <v-col class="d-flex flex-column">
            <v-card class="pb-6" outlined>
              <v-card-title>Profit</v-card-title>
              <v-card-text style="font-size:25px;"><h1>${{this.results.totalProfit}}</h1></v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title><h2>Totals Per Tailor</h2></v-card-title>
              <v-card-text>
                <v-data-table outlined
                    :headers="totalsPerTailorTable.headers"
                    :items="results.tailors"
                    item-key="id"
                    :items-per-page="15"
                    class="elevation-1"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </span>
    </span>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations} from 'vuex'
import axios from 'axios';
import moment from 'moment';
// import authorizer from '../components/authorizer.vue';
// import { Line } from 'vue-chartjs'
export default {
  name: 'Home',
  components: {
    // authorizer
  },
  computed: {
    ...mapGetters(['getUsername', 'getEndpoint', 'scanBus', 'getPerms', 'isAllowed']),
  },
  data () {
    return {
      loader: true,
      calenderLoader: false,
      startDate: (new Date(new Date('Jan 1, 2022') - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      endDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      startDateMenu: false,
      endDateMenu: false,
      snackObj: {
        color: '',
        text: ''
      },
      username: '',
      password: '',
      valid: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      allData: [],
      tailors: [],
      events: [],
      assets: [],
      users: [],
      customers: [],
      totalsPerTailorTable: {
        headers: [
        { text: 'Tailor', align: 'start', sortable: true, value: 'name' },
        { text: 'Revenue', align: 'start', sortable: true, value: 'totalRevenue' },
        { text: 'Tailor Expenses', align: 'start', sortable: true, value: 'tailorCost' },
        { text: 'Profit', align: 'start', sortable: true, value: 'totalProfit' },
        { text: 'Number of Jobs', align: 'start', sortable: true, value: 'jobs' },
        ],
        data: []
      },
      results: {},
    }
  },
  async mounted(){
    try {
      if(!this.isAllowed('user','reports')){
        console.log("not allowed")
        this.$router.push({path: '/'})
      }else {
        await this.getAllData()
      }
      moment
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapMutations([
      'lockGlobalQueryBc',
      'unlockGlobalQueryBc',
      'setScanBusData',
      'setScanBusType',
      'resetScanBus',
    ]),
    async getAllData(){
      try {
        this.loader = true
        console.log("Fetching Data")
        let res = await axios.get(`${this.getEndpoint}/api/reports/totalRevenue?start=${this.startDate}&end=${this.endDate}`)
        if(res.data.error) throw res.data.error;
        this.results = res.data.data
        let temp = []
        for(let i in this.results.tailors) temp.push({id: i, ...this.results.tailors[i]})
        this.results.tailors = temp
        console.log(this.results.tailors)
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    parseJobStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "New"
      else if(id===1) return "Sent"
      else if(id===2) return "Received"
      else if(id===3) return "Completed"
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    parseDate(date){
      if(!date) return null;
      return moment(this.parseISODate(date)).format("DD/MM/YYYY")
    },
    momentDateFormat (date) {
      return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
  }
}
</script>
